import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { colors } from "../../utils";
import Header from "./children/Header";
import { toast } from "react-toastify";
import { getUserProfileByIdAction } from "../../redux/actions";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";
import { Button, Input, TextView } from "../../components";
import CustomTabs from "../../components/CustomTabs";
import DialogModal from "../../components/DialogModal";
import { FEATURES } from "../../constants/features";
import { useIfUserEligible } from "../../hooks/useIfUserEligible";
import { openUpgradePopup } from "../../redux/reducers/upgradePopup";
import { getActiveSubscriptionData } from "../../redux/selectors/subscriptionSelectors";
import {
  connectStripeAccount,
  getBalance,
  getCommissionStructure,
  getReferralsChart,
  getStripeAccountStatus,
  getCommissionEvaluation,
} from "../../services/api";
import CustomLoader from "../../sharedcomponents/CustomLoader";
import { ASSETS } from "../../utils/config";
import { changeQueryParameters } from "../../utils/helpers";
import FeatureEligibility from "../FeatureEligibility";
import useGetAmbassadorsReferallsQuery from "./hooks/useGetAmbassadorsReferallsQuery";
import useGetBtReferallsQuery from "./hooks/useGetBtReferallsQuery";
import useGetDirectReferallsQuery from "./hooks/useGetDirectReferallsQuery";
import AmbassadorsTable from "./children/AmbassadorsTable";
import Chart from "./children/Chart";
import DirectReferralsTable from "./children/DirectReferralsTable";
import PaymentDetailsPopup from "./children/PaymentDetailsPopup";
import PercentageCard from "./children/PercentageCard";
import ReportPopup from "./children/ReportPopup";
import TriLevelReferrals from "./children/TriLevelReferrals";
import WithdrawCard from "./children/WithdrawCard";
import WithdrawalForm from "./children/WithdrawalForm";
import { ReferralProgramAPI } from "../Settings/LegalTabs/ReferralProgramAPI";
import { useGetTermsAndConditions } from "../../services/queries";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Menu,
  MenuItem,
  Checkbox,
  FormControlLabel,
  ListItemText,
  Popover,
  FormGroup,
} from "@mui/material";
import CustomPhoneInput from "../PhoneInput";
import SearchIcon from "@mui/icons-material/Search";
import RowsPerPageDropdown from "../../components/Table/RowsPerPageDropdown";
import FilterListIcon from "@mui/icons-material/FilterList";
import PayoutsCard from "./children/PayoutsCard";
import { isSafari } from "../../utils/browserDetection";
import CloseIcon from "@mui/icons-material/Close";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const Wrapper = styled.div`
  width: 96%;
  margin: auto;
  margin-top: 20px;
`;

const Content = styled.div`
  background-color: ${colors.white};
  border-radius: 10px;
  margin-top: 20px;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: ${colors.white};
  padding: 40px 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 900px;
  min-width: 700px;
  position: relative;
`;

const IframeWrapper = styled.div`
  max-height: 80vh;
  overflow-y: scroll;
`;

const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  font-size: 28px;
  font-weight: bold;
  color: ${colors.textSecondary};
  &:hover {
    color: ${colors.danger};
  }
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const BlurWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const BlurContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #333;
  text-align: center;
  border-radius: 8px;
  backdrop-filter: blur(4px);
  z-index: 10;
`;

const Row = styled.div`
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
`;

const PercentageRow = styled.div`
  display: flex;
`;

const DashboardContainer = styled.div`
  border: 1px solid ${colors.lightBorder};
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 20px;
`;

const DashboardRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr 3.25fr;
  grid-gap: 20px;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 40px;
`;

const InviteBox = styled.div`
  width: 60%;
  margin: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  text-align: center;
`;

const ReferralContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const ReferralBox = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  padding: 5px 6px 6px 10px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  height: 42px;
`;

const ReferralLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const HeaderIcon = styled.img`
  width: 40px;
  height: 40px;
`;

const CopyIconContainer = styled.div`
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 8px;
  background-color: #f0f2f5;
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ReferralValue = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const SearchBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 35px;
  margin-bottom: 10px;
  border-radius: 5px;
  background-color: #9b5af8;
  padding: 6px;
  cursor: pointer;
`;

const FilterButton = styled.div`
  display: flex;
  align-items: center;
  padding: 8.86px;
  border: 1px solid #e1e1e1;
  border-radius: 4.43px;
  background-color: white;
  cursor: pointer;
  gap: 8.86px;
  height: 44.71px;

  &:hover {
    background-color: #f9fafb;
  }
`;

const FilterContainer = styled.div`
  padding: 16px;
  width: 250px;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  border-radius: 8px;
`;

const StyledCheckbox = styled(Checkbox)`
  &.MuiCheckbox-root {
    color: #9b5af8;
  }
  &.Mui-checked {
    color: #9b5af8;
  }
`;

const FilterFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  gap: 8px;
`;

// Styled components for payment redirect modal
const PaymentRedirectModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000002;
`;

const PaymentModalContent = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 32px;
  max-width: 450px;
  width: 90%;
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
`;

const PaymentModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const PaymentCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f5f5f5;
  }
`;

const PaymentRedirectButton = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const subscriptionOptions = {
  ambassadors: [
    { value: "premium", label: "Premium" },
    { value: "proSuite", label: "ProSuite" },
  ],
  referrals: [
    { value: "inactive", label: "Inactive" },
    { value: "free", label: "Free" },
    { value: "essential", label: "Essential" },
    { value: "premium", label: "Premium" },
    { value: "proSuite", label: "ProSuite" },
  ],
};

const premiumTabs = ["Direct Referrals"];
const ambassadorTabs = [
  "Ambassadors",
  "Direct Referrals",
  "Tri-level Referrals",
];

// Define tooltips for ambassador tabs
const tabTooltips = {
  Ambassadors: "All Ambassadors in your Tri-Level Network",
  "Direct Referrals":
    "Everyone linked to your Referral Code, excluding your Ambassadors",
  "Tri-level Referrals":
    "Everyone linked to you through your Ambassador Network, excluding your Ambassadors",
};

export default function Referrals() {
  const { userProfile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [rowsPerPage, setRowsPerPage] = useState(
    parseInt(searchParams.get("limit") || "10")
  );
  const [tabIndex, setTabIndex] = useState(0);
  const [balance, setBalance] = useState(0);
  const [initialBalance, setInitialBalance] = useState(0);
  const [bankDetails, setBankDetails] = useState(undefined);
  const [cardDetails, setCardDetails] = useState(undefined);
  const [withdrawModalOpen, setWithdrawModalOpen] = useState(false);
  const [filter, setFilter] = useState("all");
  const [date, setDate] = useState(new Date());
  const [chartType, setChartType] = useState("revenue");
  const [chartData, setChartData] = useState();
  const [loading, setLoading] = useState(true);
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [accountStatusCompleted, setAccountStatusCompleted] = useState(false);
  const [accountStatusLoading, setAccountStatusLoading] = useState(true);
  const { data: currentPlan } = useSelector(getActiveSubscriptionData);
  const [openPaymentStatusModal, setOpenPaymentStatusModal] = useState(false);
  const [commissionStructure, setCommissionStructure] = useState(null);
  const [isCommissionLoading, setIsCommissionLoading] = useState(false);
  const [showReferralTerms, setShowReferralTerms] = useState(false);
  const [accepting, setAccepting] = useState(false);
  const [phoneNumberInputModal, setPhoneNumberInputModal] = useState(false);
  const [phoneData, setPhoneData] = useState(null);
  const [subscriptionFilters, setSubscriptionFilters] = useState([]);
  const [isInactiveFilter, setIsInactiveFilter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [payoutsData, setPayoutsData] = useState(null);
  const [isPayoutsLoading, setIsPayoutsLoading] = useState(true);
  const [pendingUrl, setPendingUrl] = useState(null);
  const [isPaymentRedirectModalOpen, setIsPaymentRedirectModalOpen] =
    useState(false);
  const {
    data: termsData,
    isLoading: termsLoading,
    error: termsError,
  } = useGetTermsAndConditions({}, true);

  const {
    isEligible,
    subscription,
    isCheckingEligibility,
    requiredSubscription,
    isAppropriateSubscription,
    isInReferralProgram,
  } = useIfUserEligible(FEATURES.REFFERAL_PROGRAM);

  console.log(isEligible, isInReferralProgram, "isEligible");

  const location = useLocation();
  const status = location.pathname.includes("status");

  // Browser detection
  const browserIsSafari = isSafari();

  const userType = userProfile?.referral_type ?? null;

  const isFoundingAmbassador = userProfile?.user_type === 2;

  // Determine which APIs should be enabled based on current tab and user type
  const isPremiumUser = userType === "Premium";

  const isDirectReferralsTabActive =
    (isPremiumUser && tabIndex === 0) || (!isPremiumUser && tabIndex === 1);

  const isAmbassadorsTabActive = !isPremiumUser && tabIndex === 0;

  const isBtTabActive = !isPremiumUser && tabIndex === 2;

  const { DirectReferrals, isDirectLoading, totalDirectRecords } =
    useGetDirectReferallsQuery(isDirectReferralsTabActive);
  const { BtReferrals, isBtLoading, totalBtRecords } =
    useGetBtReferallsQuery(isBtTabActive);
  const { isAmbassadorLoading, AmbassadorReferrals, totalAmbassadorRecords } =
    useGetAmbassadorsReferallsQuery(isAmbassadorsTabActive);

  const {
    first_name,
    last_name,
    email,
    phone_number,
    country_code,
    user_type,
  } = userProfile;

  useEffect(() => {
    getChartData();
  }, [date, chartType]);

  useEffect(() => {
    fetchCommissionEvaluation();
  }, []);

  useEffect(() => {
    getWithdrawBalance();
  }, [withdrawModalOpen]);

  // Debounce search
  useEffect(() => {
    if (searchText === "") {
      setSearchInUrl("");
      return;
    }

    const debounceTimer = setTimeout(() => {
      setSearchInUrl(searchText);
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [searchText]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setSearchInUrl(searchText);
    }
  };

  useEffect(() => {
    getAccountStatus();
  }, []);

  useEffect(() => {
    getCommissionStructureData();
  }, []);

  const getAccountStatus = async () => {
    try {
      const response = await getStripeAccountStatus();
      if (response?.data) {
        setAccountStatusCompleted(response?.data?.status === "Complete");
        if (status) {
          setOpenPaymentStatusModal(true);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setAccountStatusLoading(false);
    }
  };

  const onClickWithdraw = () => {
    if (!accountStatusCompleted) {
      setOpenPaymentStatusModal(true);
    } else {
      setWithdrawModalOpen(true);
    }
  };

  const getChartData = async () => {
    setLoading(true);
    const timeFrame =
      filter === "all"
        ? "all_time"
        : filter == "year"
        ? moment(date).format("YYYY")
        : moment(date).format("YYYY-MM");
    const response = await getReferralsChart(chartType, timeFrame);
    setLoading(false);
    if (response.data.success) {
      setChartData(response.data.data);
    }
  };

  const onClickContinueSetup = async () => {
    let res = await connectStripeAccount();
    if (res?.data) {
      setOpenPaymentStatusModal(false);
      window.open(res?.data?.url, "_blank");
    }
  };

  const getWithdrawBalance = async () => {
    const response = await getBalance();
    if (response?.data) {
      setBalance(response?.data?.available_balance / 100);
      setInitialBalance(response?.data?.available_balance / 100);
      setBankDetails(response?.data?.bank_details);
      setCardDetails(response?.data?.card_details);
    }
  };

  const getCommissionStructureData = async () => {
    setIsCommissionLoading(true);
    try {
      const response = await getCommissionStructure();
      if (response?.data?.success) {
        setCommissionStructure(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching commission structure:", error);
    } finally {
      setIsCommissionLoading(false);
    }
  };

  const fetchCommissionEvaluation = async () => {
    setIsPayoutsLoading(true);
    try {
      const response = await getCommissionEvaluation();
      if (response.data.success) {
        setPayoutsData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching commission evaluation:", error);
    } finally {
      setIsPayoutsLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    setSubscriptionFilters([]);
    setIsInactiveFilter(false);

    const queryParams = changeQueryParameters(searchParams, {
      sub_filter: null,
      is_active: null,
      offset: 0,
      order_by: 0,
      order_direction: 0,
    });
    setSearchParams(queryParams);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleCancel = () => {
    setSearchText("");
    setSearchInUrl("");
  };

  const setSearchInUrl = (value) => {
    const queryParams = changeQueryParameters(searchParams, {
      search: value,
      offset: 0,
    });
    setSearchParams(queryParams);
  };

  const handleCopyCode = () => {
    if (userProfile?.code) {
      navigator.clipboard.writeText(userProfile.code);
      toast.success("Referral code copied to clipboard");
    }
  };

  // Payment handling functions
  const handleOpenPaymentPage = () => {
    window.open(pendingUrl, "_blank");
    setIsPaymentRedirectModalOpen(false);
    setPendingUrl(null);
  };

  const handleClosePaymentPopup = () => {
    setPendingUrl(null);
    setIsPaymentRedirectModalOpen(false);
  };

  const startStripeFlow = async () => {
    setAccepting(true);
    let payload = {};
    if (phoneData?.phone_number) {
      payload = {
        phone_number: phoneData?.phone_number,
        country_code: phoneData?.country_code,
        country: phoneData?.country,
      };
    } else {
      payload = {
        phone_number: userProfile?.phone_number,
        country_code: userProfile?.country_code,
        country: userProfile?.country,
      };
    }
    const response = await connectStripeAccount(payload);
    if (response?.data?.url) {
      setAccepting(false);
      setPhoneData(null);
      setShowReferralTerms(false);

      // Handle Safari browser differently to avoid popup blockers
      if (browserIsSafari) {
        setPendingUrl(response.data.url);
        setIsPaymentRedirectModalOpen(true);
      } else {
        window.open(response.data.url, "_blank");
      }
    }
  };

  const openReferralTerms = () => {
    if (userProfile?.country) {
      setShowReferralTerms(true);
    } else {
      setPhoneNumberInputModal(true);
    }
  };

  const canJoinReferralProgram = () => {
    return (
      !isCheckingEligibility &&
      isAppropriateSubscription &&
      !isInReferralProgram
    );
  };

  const cannotJoinReferralProgram = () => {
    return (
      !isCheckingEligibility &&
      !isAppropriateSubscription &&
      !isInReferralProgram
    );
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    // Calculate current offset and ensure it's aligned with the new limit
    const currentOffset = parseInt(searchParams.get("offset") || "0");
    const currentPosition = currentOffset + 1; // Position of the first item on current page

    // Calculate new offset to keep user at approximately the same position in the data
    const newOffset =
      Math.floor((currentPosition - 1) / newRowsPerPage) * newRowsPerPage;

    const queryParams = changeQueryParameters(searchParams, {
      limit: newRowsPerPage,
      offset: newOffset,
    });
    setSearchParams(queryParams);
  };

  const onClickApply = () => {
    if (userProfile?.ambassador_applied)
      toast.error("You have already applied to be an ambassador");
    else setOpenModal(true);
  };

  const onClose = () => {
    dispatch(getUserProfileByIdAction(userProfile?.user_id));
    setOpenModal(false);
  };

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const handleFilterChange = (value) => {
    if (value === "inactive") {
      setIsInactiveFilter(!isInactiveFilter);
      return;
    }

    setSubscriptionFilters((prev) => {
      if (prev.includes(value)) {
        return prev.filter((item) => item !== value);
      } else {
        return [...prev, value];
      }
    });
  };

  const clearFilters = () => {
    setSubscriptionFilters([]);
    setIsInactiveFilter(false);

    // Create new URLSearchParams and clear filter parameters
    const newSearchParams = new URLSearchParams(searchParams);

    // Clear filter parameters
    newSearchParams.delete("sub_filter");
    newSearchParams.delete("is_active");
    newSearchParams.set("offset", "0"); // Reset to first page

    setSearchParams(newSearchParams);
    handleFilterClose();
  };

  const applyFilters = () => {
    // Convert subscription filters to numbers for API
    const subFilters = subscriptionFilters
      .map((filter) => {
        switch (filter) {
          case "free":
            return 0;
          case "essential":
            return 1;
          case "premium":
            return 2;
          case "proSuite":
            return 3;
          default:
            return null;
        }
      })
      .filter((value) => value !== null && value !== undefined);

    // Create new URLSearchParams to handle multiple sub_filter values correctly
    const newSearchParams = new URLSearchParams(searchParams);

    // Clear existing sub_filter parameters
    newSearchParams.delete("sub_filter");

    // Add each sub_filter value individually
    subFilters.forEach((filter) => {
      newSearchParams.append("sub_filter", filter);
    });

    // Handle is_active parameter - only set if inactive filter is selected
    if (isInactiveFilter) {
      newSearchParams.set("is_active", "false");
    } else {
      newSearchParams.delete("is_active");
    }

    newSearchParams.set("offset", "0"); // Reset to first page

    setSearchParams(newSearchParams);
    handleFilterClose();
  };

  const open = Boolean(anchorEl);

  // Get the appropriate filter options based on the current tab
  const getCurrentFilterOptions = () => {
    const options = [];

    // For Premium users, only Direct Referrals tab is shown (tabIndex 0)
    // For non-Premium users: tabIndex 0 = Ambassadors, tabIndex 1 = Direct Referrals, tabIndex 2 = BT
    const isAmbassadorsTab = userType !== "Premium" && tabIndex === 0;
    const isDirectReferralsTab =
      (userType === "Premium" && tabIndex === 0) ||
      (userType !== "Premium" && tabIndex === 1);
    const isBtTab = userType !== "Premium" && tabIndex === 2;

    // Add inactive filter for direct referrals and BT tabs, and also for Ambassadors
    if (isDirectReferralsTab || isBtTab || isAmbassadorsTab) {
      options.push({ value: "inactive", label: "Inactive" });
    }

    // Add subscription filters
    if (isAmbassadorsTab) {
      // Ambassadors tab - only Premium and ProSuite
      options.push(
        { value: "premium", label: "Premium" },
        { value: "proSuite", label: "ProSuite" }
      );
    } else {
      // Direct referrals or BT tab - all subscription types
      options.push(
        { value: "free", label: "Free" },
        { value: "essential", label: "Essential" },
        { value: "premium", label: "Premium" },
        { value: "proSuite", label: "ProSuite" }
      );
    }

    return options;
  };

  // Render the referrals dashboard section
  const renderReferralsSection = () => {
    return (
      <>
        <DashboardHeader>
          <TextView variant="largeTitle">
            <img
              src={ASSETS.Referrals}
              style={{ marginRight: 5 }}
              alt="referrals"
            />
            {isFoundingAmbassador
              ? "Founding Ambassador Referrals Dashboard"
              : "Referrals Dashboard"}
          </TextView>

          {isInReferralProgram && (
            <ReferralContainer>
              <ReferralBox>
                <ReferralLabel>
                  <TextView color={"#565556"} style={{ fontSize: "15px" }}>
                    Referral ID:
                  </TextView>
                  <TextView
                    color={"#123051"}
                    variant="subtitle"
                    style={{ fontSize: "15px" }}
                  >
                    {userProfile?.code}{" "}
                  </TextView>
                </ReferralLabel>
                <CopyIconContainer>
                  <ContentCopyIcon
                    style={{
                      fontSize: 18,
                      cursor: "pointer",
                      color: colors.PrimaryPurple,
                    }}
                    onClick={handleCopyCode}
                  />
                </CopyIconContainer>
              </ReferralBox>
              {/* <Button
                style={{ width: 150, height: 42 }}
                onClick={() => setReportOpen(true)}
              >
                Download Report
              </Button> */}
            </ReferralContainer>
          )}
        </DashboardHeader>

        {isCheckingEligibility && <CustomLoader />}

        <div style={{ position: "relative" }}>
          {!isCheckingEligibility && !isInReferralProgram && (
            <>
              {isAppropriateSubscription && (
                <DialogModal
                  open={true}
                  title="Start earning rewards by sharing the love!"
                  message="Join our Earnings Program today and get exclusive benefits for you and your friends. It's easy to get started—just share your unique link and watch the rewards roll in."
                  primaryButton="Sign Up"
                  onPrimaryPress={openReferralTerms}
                  allowClose={false}
                  isModal={false}
                />
              )}

              {!isAppropriateSubscription && (
                <DialogModal
                  open={true}
                  title="Start Earning Referral Revenue!"
                  message="Upgrade to Premium or higher and join our Earnings Program today. Build wheels and share them—if people sign up while viewing your wheel, they'll be automatically connected to your account, and the rewards will start rolling in."
                  primaryButton="Upgrade"
                  onPrimaryPress={() => dispatch(openUpgradePopup())}
                  allowClose={false}
                  isModal={false}
                />
              )}
            </>
          )}

          <BlurWrapper>
            <DashboardContainer>
              <DashboardRow>
                <WithdrawCard
                  onClick={onClickWithdraw}
                  balance={initialBalance}
                  onShowPaymentDetails={() => setShowPaymentDetails(true)}
                />
                <PayoutsCard data={payoutsData} loading={isPayoutsLoading} />
                <Chart
                  filter={filter}
                  setFilter={setFilter}
                  date={date}
                  setDate={setDate}
                  chartType={chartType}
                  setChartType={setChartType}
                  chartData={chartData}
                  getChartData={getChartData}
                  loading={loading}
                />
              </DashboardRow>
            </DashboardContainer>

            <CustomTabs
              value={tabIndex}
              onChange={handleTabChange}
              tabs={userType == "Premium" ? premiumTabs : ambassadorTabs}
              tooltips={userType != "Premium" ? tabTooltips : {}}
            />

            <SearchContainer>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <Input
                  isSearch={true}
                  placeholder="Search"
                  value={searchText}
                  onClear={handleCancel}
                  showClearIcon={searchText.length !== 0}
                  onKeyUp={handleKeyPress}
                  onChange={handleSearch}
                  variant={"secondary"}
                  containerStyle={{ width: 200, marginTop: 10 }}
                />

                <SearchBox onClick={() => setSearchInUrl(searchText)}>
                  <SearchIcon style={{ color: colors.white }} />
                </SearchBox>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <FilterButton onClick={handleFilterClick}>
                  <FilterListIcon style={{ color: "#9B5AF8", fontSize: 20 }} />
                  <span style={{ color: "#565556" }}>Filter</span>
                  {(subscriptionFilters.length > 0 || isInactiveFilter) && (
                    <span
                      style={{
                        backgroundColor: "#9B5AF8",
                        color: "white",
                        borderRadius: "50%",
                        width: "20px",
                        height: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                      }}
                    >
                      {subscriptionFilters.length + (isInactiveFilter ? 1 : 0)}
                    </span>
                  )}
                </FilterButton>

                <Popover
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleFilterClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <FilterContainer>
                    <FormGroup>
                      {getCurrentFilterOptions().map((option) => (
                        <FormControlLabel
                          key={option.value}
                          control={
                            <StyledCheckbox
                              checked={
                                option.value === "inactive"
                                  ? isInactiveFilter
                                  : subscriptionFilters.includes(option.value)
                              }
                              onChange={() => handleFilterChange(option.value)}
                            />
                          }
                          label={
                            <span
                              style={{
                                fontSize: "14px",
                                color: "#565556",
                                fontFamily: "DM Sans",
                              }}
                            >
                              {option.label}
                            </span>
                          }
                        />
                      ))}
                    </FormGroup>
                    <FilterFooter>
                      <Button
                        variant="outlined"
                        onClick={clearFilters}
                        style={{
                          height: "32px",
                          fontSize: "12px",
                          padding: "0 12px",
                        }}
                      >
                        Clear All
                      </Button>
                      <Button
                        onClick={applyFilters}
                        style={{
                          height: "32px",
                          fontSize: "12px",
                          padding: "0 12px",
                        }}
                      >
                        Apply
                      </Button>
                    </FilterFooter>
                  </FilterContainer>
                </Popover>

                <RowsPerPageDropdown
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                />
              </div>
            </SearchContainer>

            {userType == "Premium" && tabIndex === 0 && (
              <DirectReferralsTable
                data={DirectReferrals}
                loading={isDirectLoading}
                totalRecords={totalDirectRecords}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            )}

            {userType !== "Premium" && tabIndex === 0 && (
              <AmbassadorsTable
                data={AmbassadorReferrals || []}
                loading={isAmbassadorLoading}
                totalRecords={totalAmbassadorRecords}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            )}

            {userType !== "Premium" && tabIndex === 1 && (
              <DirectReferralsTable
                data={DirectReferrals || []}
                loading={isDirectLoading}
                totalRecords={totalDirectRecords}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            )}

            {userType !== "Premium" && tabIndex === 2 && (
              <TriLevelReferrals
                data={BtReferrals || []}
                loading={isBtLoading}
                totalRecords={totalBtRecords}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            )}

            {!isInReferralProgram && <BlurContainer />}
          </BlurWrapper>
        </div>
      </>
    );
  };

  return (
    <>
      <Wrapper>
        {user_type !== 2 && isInReferralProgram && (
          <Header
            title="Apply to be an Ambassador"
            text="Boost your commission and expand your referral network through our Tri-Level structure!"
            buttonText={
              userProfile?.ambassador_applied ? "Applied" : "Apply Now"
            }
            onButtonPress={onClickApply}
            disabled={userProfile?.ambassador_applied}
          />
        )}

        <Content>{renderReferralsSection()}</Content>

        {openModal && (
          <ModalOverlay>
            <ModalContent>
              <CloseButton onClick={onClose}>×</CloseButton>
              <IframeWrapper>
                <Iframe
                  src={`https://link.iyuga.net/widget/form/rZUfwCCaAHv7bIPKQ9xe?notrack=true&first_name=${first_name}&last_name=${last_name}&email=${email}&phone=${country_code}${phone_number}`}
                  title="Apply Now Form"
                />
              </IframeWrapper>
            </ModalContent>
          </ModalOverlay>
        )}
      </Wrapper>

      <WithdrawalForm
        bankDetails={bankDetails}
        cardDetails={cardDetails}
        balance={balance}
        setBalance={setBalance}
        initialBalance={initialBalance}
        setInitialBalance={setInitialBalance}
        isOpen={withdrawModalOpen}
        onClose={() => setWithdrawModalOpen(false)}
      />

      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showReferralTerms}
        onClose={() => setShowReferralTerms(false)}
      >
        <DialogContent>
          <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
            <HeaderIcon src={ASSETS.Insurance} />
            <TextView variant="title">iYuga's Referral Policy</TextView>
          </DialogTitle>
          <ReferralProgramAPI
            data={termsData}
            isLoading={termsLoading}
            error={termsError}
          />
        </DialogContent>
        <DialogActions
          sx={{ width: "20%", display: "flex", alignSelf: "flex-end" }}
        >
          <Button
            variant={"secondary"}
            style={{ width: "auto" }}
            onClick={() => setShowReferralTerms(false)}
          >
            Cancel
          </Button>
          <Button isLoading={accepting} onClick={startStripeFlow}>
            I Accept
          </Button>
        </DialogActions>
      </Dialog>

      <DialogModal
        open={phoneNumberInputModal}
        onClose={() => setPhoneNumberInputModal(false)}
        title="Phone Number Required"
        message="Please enter your phone number to proceed with the Earnings Program."
        primaryButton="Next"
        onPrimaryPress={() => {
          setPhoneNumberInputModal(false);
          setShowReferralTerms(true);
        }}
        isPhoneInput={true}
        extraText={
          <CustomPhoneInput
            type={"phone"}
            name="phone"
            noPadding={true}
            value={phoneData?.phone || ""}
            onChange={(value) => {
              setPhoneData((prev) => ({
                ...prev,
                phone: value.phoneNumber,
                country_code: value.countryCode,
                country: value.country,
                phone_number: value.actualNumber,
              }));
            }}
          />
        }
      />

      <DialogModal
        open={openPaymentStatusModal && !accountStatusCompleted}
        onClose={() => setOpenPaymentStatusModal(false)}
        title="Oops!"
        message={`You haven't completed the setup to receive the payments. Kindly connect your bank account to start receiving the payments.`}
        icon={ASSETS.Sad}
        primaryButton={"Complete Setup"}
        secondaryButton={"Not now"}
        onPrimaryPress={onClickContinueSetup}
        onSecondaryPress={() => setOpenPaymentStatusModal(false)}
      />

      {reportOpen && (
        <ReportPopup open={reportOpen} onClose={() => setReportOpen(false)} />
      )}
      <PaymentDetailsPopup
        open={showPaymentDetails}
        onClose={() => setShowPaymentDetails(false)}
      />

      {/* Payment Redirect Popup for Safari */}
      {isPaymentRedirectModalOpen && (
        <PaymentRedirectModal>
          <PaymentModalContent>
            <PaymentModalHeader>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <AutoAwesomeIcon
                  style={{ color: " #F5CC3B", fontSize: 24, marginRight: 5 }}
                />
                <TextView variant="subtitle">
                  Complete Your Payment Setup
                </TextView>
              </div>
              <div></div>
              <PaymentCloseButton onClick={handleClosePaymentPopup}>
                <CloseIcon />
              </PaymentCloseButton>
            </PaymentModalHeader>
            <TextView style={{ marginBottom: "24px", color: "#666" }}>
              To join the Earnings Program you must set up your Stripe Connect
              account.
            </TextView>
            <PaymentRedirectButton onClick={handleOpenPaymentPage}>
              Proceed
            </PaymentRedirectButton>
          </PaymentModalContent>
        </PaymentRedirectModal>
      )}
    </>
  );
}
